import * as types from "../actions/types/index";

const INITIAL_STATE = {};

export default function (state = INITIAL_STATE, action) {

    if (action.type === types.DEVICE_INFO) {
        return {
            payload: action.payload,
        };
    }

    return {
        ...state
    }
}